import WalletPage from "./index";

/** Spot trading wallet — separate route entry so `_index` can use the standalone spot layout (`surface="spot"`). */
export default function SpotWalletPage() {
  return <WalletPage surface="spot" />;
}
